import React from "react";
import { ForceOutReportContainer } from "../../../containers";

const ForceOutReport = (props) => {
  return <ForceOutReportContainer {...props} />;
};

export default ForceOutReport;
